import React, { ReactElement } from 'react';
import { Skeleton } from 'primereact/skeleton';
import './ProjectViewSkeleton.scss';

export default function ProjectViewSkeleton(): ReactElement {
  return (
    <div style={{ width: '300px' }}>
      <div className="custom-skeleton p-p-4" style={{ paddingTop: '20px' }}>
        <div className="p-d-flex p-mb-3">
          <Skeleton shape="circle" size="4rem" className="p-mr-2" />
          <div>
            <Skeleton width="10rem" className="p-mb-2" />
            <Skeleton width="5rem" className="p-mb-2" />
            <Skeleton height=".5rem" />
          </div>
        </div>
        <Skeleton width="100%" height="150px" />
        <div className="p-d-flex p-jc-between p-mt-3">
          <Skeleton width="4rem" height="2rem" />
          <Skeleton width="4rem" height="2rem" />
        </div>
      </div>
    </div>
  );
}
